/*eslint-disable */
let BaseURL = process.env.VUE_APP_API_BASE_URL;
let consultRoots = {
// Consult Patient Url
consultPatientApiUrl: {
    "link": BaseURL + "api/account/user/doctor-patients/"
},
// Consult Patient Detail By Id Url
consultPatientDetailByIdApiUrl: {
    "link": BaseURL + "api/account/user/doctor-patient-detail/"
},
// Consult Patient Notes Url
consultPatientNotesApiUrl: {
    "link": BaseURL + "api/account/user/patient-doctor-notes/"
},
// Consult Patient Notes Url
consultPatientNotesApiUrl: {
    "link": BaseURL + "api/account/user/patient-doctor-notes/"
},
// Update Consult Appointment Details Url
updateConsultAppointmentDetailApiUrl: {
    "link": BaseURL + "api/account/user/update-doctor-appointments/"
},
// Patient Chat room Create Api Url
patientWithChatRoomCreatedApiUrl: {
    "link": BaseURL + "api/chat_app/patient_room_create/"
},
// Patient Chat room Detail Api Url
patientWithChatRoomDetailApiUrl: {
    "link": BaseURL + "api/chat_app/patient_chat/detail/"
},
// Remark For Patient Api Url
remoarkForPatientApiUrl: {
    "link": BaseURL + "api/account/user/patient-remarks/"
},
// Prescription For Patient Api Url
prescriptionForPatientApiUrl: {
    "link": BaseURL + "api/account/user/patient-prescription/"
},
patientMessageListApiUrl:{
    "link": BaseURL + "api/account/user/get-doctor-message/"
},
replyOnPatientMsgApiUrl:{
    "link": BaseURL + "api/account/user/update-doctor-message/"
},
doctorAvaibleDayTimeForConsultApiUrl:{
    "link": BaseURL + "api/account/user/doctor-schedule/"
},
patientPrescriptionReCreatedApiUrl:{
    "link": BaseURL + "api/account/user/lbil-patient-prescription/"
}
}
export default consultRoots;